import { Link, Head } from "@inertiajs/react"
import { Button } from "@/components/ui/button"

export default function Home() {
  const description =
    "ReplyOps — reply management for cold-email agencies. Ingests SmartLead replies, classifies intent, drafts responses."

  return (
    <>
      <Head title="ReplyOps">
        <meta name="description" content={description} />
        <meta property="og:title" content="ReplyOps" />
        <meta property="og:description" content={description} />
      </Head>
      <main className="mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center px-4 py-16 text-center">
        <h1>ReplyOps</h1>
        <p className="mt-2 max-w-md">Reply management for cold-email agencies.</p>
        <div className="mt-6 flex items-center gap-3">
          <Button asChild>
            <Link href="/login">Log in</Link>
          </Button>
        </div>
      </main>
    </>
  )
}
